var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-form-select',{attrs:{"options":_vm.options,"blank-option-text":_vm.nullName,"text-field":"name","dont-sort":"","value":_vm.value,"value-field":"value"},on:{"change":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }